import { SubscriberType } from './SubscriberType';

export interface Subscription {
	id: number;
	applicationPermissions: Record<string, PermissionSet>;
	seats: number;
	occupiedSeats: number;
	companyId: number;
	companyName?: string;
	type: SubscriptionType;
	status: SubscriptionStatus;
	startDate: string;
	endDate: string;
	subscriberType: SubscriberType;
	subscribers: Subscriber[];
	systemEntitySubscribers: SystemEntitySubscriber[];
	description?: string;
	bundleId?: number;
}

export interface Subscriber {
	id: string;
	name: string;
	email: string;
}

export interface SystemEntitySubscriber {
	id: string;
	displayName: string;
}

export interface PermissionSet {
	plan: string;
	countries: string[];
	addons: string[];
}

export interface ApplicationPermissionOptions {
	applicationId: string;
	applicationName: string;
	subscriberType: SubscriberType;
	plans: SubscriptionPlan[];
	addons: PermissionAddon[];
	areas: GeoNode[];
}

export interface PermissionTemplate {
	id: number;
	name: string;
	applicationPermissions: Record<string, PermissionSet>;
}

export interface Provider {
	id: number;
	code: string;
	name: string;
}

export interface PermissionAddon {
	id: number;
	code: string;
	name: string;
	applicationId: string;
	availableForBundle: boolean;
	accessibleToSalesRole: boolean;
}

export interface GeoNode {
	code: string;
	name: string;
	nodeType: GeoNodeType;
	children?: GeoNode[];
}

export enum GeoNodeType {
	Country = 'Country',
	Continent = 'Continent',
}

export interface SubscriptionPlan {
	code: string;
	displayName: string;
	applicationId: string;
}

export enum SubscriptionType {
	Trial = 'Trial',
	Paid = 'Paid',
	Free = 'Free',
	Internal = 'Internal',
}

export enum SubscriptionStatus {
	None = 'None',
	Active = 'Active',
	Expired = 'Expired',
	Canceled = 'Canceled',
	Ordered = 'Ordered',
}

export const getSubscriptionStatusColor = (status: SubscriptionStatus) => {
	switch (status) {
		case SubscriptionStatus.Active:
		case SubscriptionStatus.Ordered:
			return 'bgSuccess';
		case SubscriptionStatus.Expired:
		case SubscriptionStatus.Canceled:
			return 'bgError';
		default:
			return 'bgDefault';
	}
};
